import type React from "react";
import { useNavigate } from "react-router-dom";

import LinkArrowIcon from "@/assets/svg/link-arrow.svg?react";
import { Icon, Link, P } from "@/base/components/Global";
import { Col, Row } from "@/base/components/Layout";
import { createUseStyles } from "@/theme";

const parseURL = (url: string) => {
  try {
    const urlObject = new URL(url);
    const isExternal = urlObject.origin !== location.origin;

    return isExternal
      ? { isExternal, url: urlObject.toString() }
      : { isExternal: false, url: `${urlObject.pathname}${urlObject.search}` };
  } catch {
    return { isExternal: false, url: url };
  }
};

const useStyles = createUseStyles(({ color }) => ({
  link: {
    borderBottom: `1px solid ${color.gray5}`,
    width: "100%",
  },
}));

type FooterLinkProps = {
  name: string;
  path: string;
};

const FooterLink: React.FC<FooterLinkProps> = ({ name, path }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const openLink = () => {
    const { isExternal, url } = parseURL(path);

    if (isExternal) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };

  return (
    <Link gray2 flex bold action={openLink} className={classes.link}>
      <Col col={12}>
        <Row>
          <Col>
            <P gray2>{name}</P>
          </Col>
          <Col col={2} alignEnd>
            <Icon icon={<LinkArrowIcon />} />
          </Col>
        </Row>
      </Col>
    </Link>
  );
};

export default FooterLink;
